import { useNavigate } from "react-router-dom";
import { Box, Typography, styled } from "@mui/material";
import {
  Body,
  BottomActionButton,
  ContentContainer,
  Header,
} from "../../components";

export const DescriptionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  gap: 16,
});

export const DescriptionText = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 500,
  textAlign: "center",
  color: theme.palette.text.primary,
}));

export function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      <Header useMekiDocIcon />
      <ContentContainer disableGutters>
        <Body>
          <DescriptionContainer>
            <DescriptionText>Esta página no existe</DescriptionText>
            <BottomActionButton onClick={() => navigate("/app/solicitudes")}>
              Volver al inicio
            </BottomActionButton>
          </DescriptionContainer>
        </Body>
      </ContentContainer>
    </>
  );
}
